import { useSyncExternalStore } from 'react'
import './HomeSectionHeader.css'

// All home headers share one visibility listener. Animation stays entirely in
// CSS; switching tabs never starts timers, animation loops or network requests.
const visibilityListeners = new Set()
const notifyVisibility = () => visibilityListeners.forEach(listener => listener())
function subscribeVisibility(listener) {
  visibilityListeners.add(listener)
  if (visibilityListeners.size === 1) document.addEventListener('visibilitychange',notifyVisibility)
  return () => {
    visibilityListeners.delete(listener)
    if (!visibilityListeners.size) document.removeEventListener('visibilitychange',notifyVisibility)
  }
}
const visible = () => typeof document === 'undefined' || !document.hidden
const serverVisible = () => true

// The same filled, differently sized nodes and sparse red connections as the
// landing-page logo background. Each small network drifts as a whole in CSS.
function HeaderConstellations() {
  return <svg className="hb-home-header-network" viewBox="0 0 430 110" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">
    <g className="hb-home-header-cluster hb-home-header-cluster-three" data-network-points="3">
      <path d="M16 25 57 49 93 82"/>
      <circle cx="16" cy="25" r="2.3"/><circle cx="57" cy="49" r="4.6" className="hb-home-header-hub"/><circle cx="93" cy="82" r="3.1"/>
    </g>
    <g className="hb-home-header-cluster hb-home-header-cluster-five" data-network-points="5">
      <path d="M155 26 194 56 244 27M194 56 170 94M194 56 250 87M170 94 250 87"/>
      <circle cx="155" cy="26" r="2.4"/><circle cx="194" cy="56" r="4.8" className="hb-home-header-hub"/>
      <circle cx="244" cy="27" r="3.1"/><circle cx="170" cy="94" r="3.5"/><circle cx="250" cy="87" r="1.9"/>
    </g>
    <g className="hb-home-header-cluster hb-home-header-cluster-seven" data-network-points="7">
      <path d="M287 32 330 57 378 27M330 57 304 97M330 57 365 91M378 27 420 60M365 91 420 60 434 107"/>
      <circle cx="287" cy="32" r="2.1"/><circle cx="330" cy="57" r="5" className="hb-home-header-hub"/>
      <circle cx="378" cy="27" r="3.2"/><circle cx="304" cy="97" r="2.5"/><circle cx="365" cy="91" r="4"/>
      <circle cx="420" cy="60" r="2.7"/><circle cx="434" cy="107" r="1.8"/>
    </g>
  </svg>
}

export default function HomeSectionHeader({title,subtitle,actions,isActive = true,level = 'h2'}) {
  const pageVisible = useSyncExternalStore(subscribeVisibility,visible,serverVisible)
  const Heading = ['h2','h3','h4'].includes(level) ? level : 'h2'
  return <div className="hb-home-section-header" data-motion-paused={!isActive || !pageVisible}>
    <HeaderConstellations/>
    <div className="hb-home-section-header-copy"><Heading>{title}</Heading>{subtitle && <p>{subtitle}</p>}</div>
    {actions && <div className="hb-home-section-header-actions">{actions}</div>}
  </div>
}
